export default __webpack_public_path__ + "static/media/electronic-music.19568b23.png";